function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "e7rKWIhsl2B2",
  d: "M128.011,159.537c-23.231833-.535561-46.139624-5.569053-67.456-14.822-10.19423-4.378937-20.004699-9.602111-29.329-15.615-4.555-3.1-9.1-6.141-13.387-9.6-4.475988-3.50138-8.736412-7.269908-12.758-11.285-3.277489-3.22057-5.110462-7.631529-5.080691-12.22643s1.919746-8.981739,5.238691-12.15957c4.653566-4.465629,11.351298-6.079306,17.528-4.223l2.656.8c3.819,1.148,8.533,2.987,12.869,4.426c4.434,1.491,8.807,3.065,13.253,4.413c8.835,2.811,17.612,5.355,26.316,7.516c16.620108,4.365565,33.691328,6.784463,50.87,7.208c8.535233.067738,17.066585-.388117,25.546-1.365c8.656-.806,17.392-2.331,26.23-4.045s17.751-3.819,26.709-6.187c4.521-1.093,8.974-2.419,13.483-3.673c4.385-1.21,9.22-2.776,13.068-3.689l2.787-.662c9.374206-2.295607,18.854013,3.363946,21.281,12.705c1.486518,6.082691-.479727,12.490838-5.122,16.693-4.223086,3.848586-8.673786,7.439734-13.328,10.754-4.478,3.218-9.155,6.089-13.867,8.961-9.596757,5.569981-19.661265,10.291891-30.079,14.112-20.829786,7.841277-42.893328,11.896701-65.15,11.975q-1.139.003-2.278-.011Z",
  transform: "translate(-1.161357 48.224492)",
  fill: "#ff0660"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "e7rKWIhsl2B3",
  d: "M55.265,22.175c14.872-28.886,137.21-30.24,147.766,0C210.84,44.547,160.166,76,129.148,76C95.166,76,44.262,43.545,55.265,22.175Z",
  transform: "translate(-1.161357 48.224492)",
  fill: "#ff0660"
});

function SvgAppLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e7rKWIhsl2B1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLoader);
export default __webpack_public_path__ + "static/media/app-loader.ece94a61.svg";
export { ForwardRef as ReactComponent };